import React from 'react'
import './spinner2.css'

const Spinner2 = () => {
  return (
    <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
  )
}

export default Spinner2